import { render, staticRenderFns } from "./EmailLogin.vue?vue&type=template&id=3c44784c&"
import script from "./EmailLogin.vue?vue&type=script&lang=ts&"
export * from "./EmailLogin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports